import { BackgroundStyle } from './Counter.theme.utils';
export var counterTheme = {
  baseStyle: _ref => {
    var {
      status,
      isFixedSize
    } = _ref;
    return {
      paddingX: isFixedSize ? 'none' : 'xxs',
      textStyle: 'caption2Semi',
      display: 'inline-flex',
      minWidth: '16px',
      height: '16px',
      borderRadius: 'full',
      backgroundColor: BackgroundStyle[status],
      color: status === 'warning' ? 'neutral.black' : 'neutral.white',
      width: 'fit-content',
      alignItems: 'center',
      justifyContent: 'center'
    };
  }
};
//# sourceMappingURL=Counter.theme.js.map